export default __webpack_public_path__ + "static/media/visacard.4168fc80.svg";